__turbopack_context__.v({
  "arrowRightIcon": "Jcmlqq_arrowRightIcon",
  "article": "Jcmlqq_article",
  "linkContainer": "Jcmlqq_linkContainer",
  "previewArticle": "Jcmlqq_previewArticle",
});
